@if (match) {
    <div class="match">
        <mat-icon class="!text-success-50 bg-success-800 rounded-full"
            >check</mat-icon
        >
        <span class="match-text">Match</span>
    </div>
} @else {
    <div class="no-match">
        <mat-icon class="!text-primary-50 bg-primary-800 rounded-full"
            >error_outline</mat-icon
        >
        <span class="no-match-text">New Company</span>
    </div>
}
